import React, { useEffect, useState } from "react";
import { Button, Col, Form, Input, InputNumber, message, Modal, Popconfirm, Row, Select, SelectProps, Spin } from "antd";
import { useCompany } from "../../contexts/CompanyContext";
import { useConfig } from "../../contexts/ConfigContext";
import { mutate } from "swr";
import { TCashSession, useSession } from "../../contexts/CashSessionContext";
import Search, { SearchProps } from "antd/es/input/Search";
import { useUser } from "../../contexts/UserContext";
import { formatInputNumber, parseInputNumber } from "../../utils";
import { usePos } from "../../contexts/PosContext";
import { useSecureRequest } from "../../hooks/useSecureRequest";
import { useCashRegister } from "../../contexts/CashRegisterContext";

interface IformValues {
  cash_register_id: number;
  cashier_id: number;
  difference: number | null;
  final_amount: number | null;
  initial_amount: number | null;
  opened_by_document: string,
  total_sales_cash: number | null;
  total_sales_non_cash: number | null;
  cashier_name: string,
  cashier_document: string,
  opened_by_name: string,
  cash_register_alias: string,
}

type TRequestData = {
  company: string | null,
  module: string,
  uidPos: string,
  uidSession?: string
  cashSession: Partial<TCashSession>,
}
function CashSessionModal(){
  const {session,updateSession} = useSession()
  const {cashRegister} = useCashRegister()
  const {user} = useUser()
  const {company} = useCompany()
  const {pos} = usePos()
  const {config} = useConfig()
  const { Option } = Select
  const [form] = Form.useForm<IformValues>()
  const [loading, setLoading] = useState(false)
  const [messageApi, contextHolder] = message.useMessage();
  const currentData = !!session.current?.uid
  const { securePost } = useSecureRequest()

  useEffect(()=>{
    if(session.current){
      form.setFieldsValue(session.current)
    }else{
      form.setFieldsValue({
        opened_by_name: user.name,
        opened_by_document: user.document_number,
        cashier_id: undefined,
        cashier_name: undefined,
        cash_register_id: undefined,
        initial_amount:0
      })
    }
  },[session.current,session.showModal])

  console.log("Current session",session.current)
  const handleSession = async (values:IformValues) => {
    setLoading(true)
    let dataRequest:TRequestData = {
      company:company.current.uid,
      module: config.module,
      uidPos: pos.currentSelected.uid,
      cashSession: {
        ...values,
        opened_by_id: user.id,
        status: "OPEN",
        pos_uid: pos.currentSelected.uid
      }
    }
    let url = "/sale/cash-session/create-session"
    if(currentData){
      dataRequest = {
        company:company.current.uid,
        module: config.module,
        uidPos: pos.currentSelected.uid,
        uidSession: session.current.uid || "",
        cashSession: {
          id: session.current.id,
          status: "CLOSED"
        }
      }
      url = "/sale/cash-session/update-session"
    }
    const storeResponse = await securePost(url,dataRequest)
    if(storeResponse.status === 200){
      mutate(key => Array.isArray(key) && typeof key[0] === 'string' && key[0].startsWith('/sale/cash-session/get-session'), undefined, { revalidate: true })
      updateSession({showModal:false,current:undefined})
      form.setFieldsValue({})
      success(currentData? 'Registro actualizado con éxito':'Registro creado con éxito')
    }else{
      fail("Por favor intente nuevamente")
    }
    setLoading(false)
  }
  const success = (content:string) => {
    messageApi.open({
      type: 'success',
      content,
    });
  };
  const fail = (content:string) => {
    messageApi.open({
      type: 'error',
      content,
    });
  };

  const onClose = () => {
    updateSession({showModal:false,current:undefined})
    form.resetFields()
    form.setFieldsValue({})
  }
  const footer = [
    <Popconfirm
      key="confirm"
      title="¿Estás seguro de realizar esta acción?"
      okButtonProps={{htmlType:"submit",form:"cash-session-form"}}
      okText="Sí"
      cancelText="No"
    >
      <Button type="primary" htmlType="button">Crear</Button>
    </Popconfirm>,
    <Button 
      key="cancel" 
      type="default" 
      htmlType="button" 
      onClick={onClose}>Cancelar
    </Button>
  ]
  if(currentData && session.current.status !== "CLOSED"){
    footer[0] = <Popconfirm
      key="confirm"
      title="¿Estás seguro de realizar esta acción?"
      okButtonProps={{htmlType:"submit",form:"cash-session-form"}}
      okText="Sí"
      cancelText="No"
    >
      <Button type="primary" htmlType="button">Finalizar</Button>
    </Popconfirm>
  }
  if(currentData && session.current.status === "CLOSED"){
    footer.shift()
  }
  const onClear: SearchProps['onClear'] = () => {
    form.setFieldValue("cashier_name","")
  };

  const onSearch: SearchProps['onSearch'] = (value) => {
    if (value.trim() === '') {
      return;
    }
    const foundById = session.list.some(el => el.status !== "CLOSED" && el.cashier_document === value)
    if(foundById){
      return fail("Ya existe un registro vigente para el usuario " + value)
    }
    setLoading(true);

    (async () => {
      const userResponse = await securePost('/security/base/get-user-by-id',{
        id:value
      })
      if(userResponse.status === 200 && userResponse.user.id){
        form.setFieldsValue({
          cashier_name:userResponse.user.name,
          cashier_id:userResponse.user.id,
          cashier_document:userResponse.user.document_number
        })

        console.log("Usuario:",userResponse.user)
      }else{
        fail("Usuario no encontrado")
      }
      setLoading(false)
    })()
  }
  const cashierName = Form.useWatch("cashier_name",form)

  const onSelectCashRegister:SelectProps['onSelect'] = (value: number) => {
    form.setFieldValue("cash_register_alias",cashRegister.list.find(el => el.id === value)?.alias)
  }
  return (
    <Modal
      title={<div style={{ textAlign: "center" }}>Datos de sesión</div>}
      open={session.showModal}
      maskClosable={false}
      confirmLoading={loading}
      onCancel={onClose}
      className="modal-responsive-md"
      destroyOnHidden
      footer={footer}
      >
      <Spin size="large" tip="Procesando..." fullscreen spinning={loading} />
      {contextHolder}
      <Form
        form={form}
        name="cash-session-form"
        layout="vertical"
        scrollToFirstError={{ block: 'end', focus: true }}
        style={{ maxWidth: '800px', margin: '0 auto'}}
        onFinish={handleSession}>
        <Form.Item hidden name={`cashier_id`}><Input type="text" /></Form.Item>
        <Form.Item hidden name={`cash_register_alias`}><Input type="text" /></Form.Item>
        <Row gutter={[10,10]} style={{marginBottom:20}}>
          <Col sm={12} xs={24}>
            <Form.Item
              label="ID Aperturador"
              name={`opened_by_document`}
              rules={[{ required: true, message: 'Ingrese un id valido'}]}
            >
              <InputNumber type="number" disabled minLength={3} maxLength={12} style={{ width: "100%" }}/>
            </Form.Item>
          </Col>
          <Col sm={12} xs={24}>
            <Form.Item
              label="Nombre Aperturador"
              name={`opened_by_name`}
              rules={[{ required: true, message: 'Ingrese un nombre valido'}]}
            >
              <Input type="text" disabled minLength={3} maxLength={30}/>
            </Form.Item>
          </Col>
          <Col sm={12} xs={24}>
            <Form.Item
              label="ID Cajero"
              name={`cashier_document`}
              rules={[{ required: true, message: 'Ingrese un ID'}]}
            >
              <Search placeholder="# identificación" 
              allowClear onSearch={onSearch}
              onClear={onClear}
              maxLength={15}
              min={0}
              type="number"
              disabled={!!cashierName}
              inputMode="numeric"
              pattern="[0-9]*"
              style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col sm={12} xs={24}>
            <Form.Item
              label="Nombre Cajero"
              name={`cashier_name`}
              rules={[{ required: true, message: ''}]}
            >
              <Input type="text" disabled minLength={3} maxLength={30}/>
            </Form.Item>
          </Col>
          <Col sm={12} xs={24}>
            <Form.Item
              label="ID Caja"
              name={`cash_register_id`}
              rules={[{ required: true, message: ''}]}
            >
              <Select placeholder="Seleccione un almacén" disabled={currentData} onSelect={onSelectCashRegister}>
                {
                  cashRegister.list.map(el => <Option key={el.uid} value={el.id}>{el.name}</Option>)
                }
              </Select>
            </Form.Item>
          </Col>
          <Col sm={12} xs={24}>
            <Form.Item
              label="Efectivo Base"
              name={`initial_amount`}
              rules={[{ required: true, message: ''}]}
            >
              <InputNumber type="text" min={0} disabled={currentData}
                prefix="$" style={{ width: '100%' }}
                formatter={formatInputNumber}
                parser={parseInputNumber}/>
            </Form.Item>
          </Col>
          {currentData &&<> <Col sm={12} xs={24}>
            <Form.Item
              label="Efectivo en caja"
              name={`total_sales_cash`}
              rules={[{ required: true, message: ''}]}
            >
              <InputNumber type="text" min={0} disabled={currentData}
                prefix="$" style={{ width: '100%' }}
                formatter={formatInputNumber}
                parser={parseInputNumber}/>
            </Form.Item>
          </Col>
          <Col sm={12} xs={24}>
            <Form.Item
              label="Pagos electrónicos"
              name={`total_sales_non_cash`}
              rules={[{ required: true, message: ''}]}
            >
              <InputNumber type="text" min={0} disabled={currentData}
                prefix="$" style={{ width: '100%' }}
                formatter={formatInputNumber}
                parser={parseInputNumber}/>
            </Form.Item>
          </Col>
          <Col sm={12} xs={24}>
            <Form.Item
              label="Total facturado"
              name={`final_amount`}
              rules={[{ required: true, message: ''}]}
            >
              <InputNumber type="text" min={0} disabled={currentData}
                prefix="$" style={{ width: '100%' }}
                formatter={formatInputNumber}
                parser={parseInputNumber}/>
            </Form.Item>
          </Col>
          </>}
        </Row>
      </Form>
    </Modal>
  )

}

export default CashSessionModal